module.exports = __webpack_public_path__ + "static/media/38.f7c3ea3c.jpg";